/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_HardcoverInputs */

const en_val_hardcover = /** @type {(inputs: Val_HardcoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hardcover`)
};

const es_val_hardcover = /** @type {(inputs: Val_HardcoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tapa dura`)
};

const fr_val_hardcover = /** @type {(inputs: Val_HardcoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relié`)
};

const de_val_hardcover = /** @type {(inputs: Val_HardcoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gebundene Ausgabe`)
};

const ja_val_hardcover = /** @type {(inputs: Val_HardcoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ハードカバー`)
};

const zh_val_hardcover = /** @type {(inputs: Val_HardcoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`精装本`)
};

const ar_val_hardcover = /** @type {(inputs: Val_HardcoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`غلاف مقوى`)
};

const id_val_hardcover = /** @type {(inputs: Val_HardcoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sampul Keras`)
};

const it_val_hardcover = /** @type {(inputs: Val_HardcoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copertina Rigida`)
};

const ru_val_hardcover = /** @type {(inputs: Val_HardcoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Твердая обложка`)
};

const pt_val_hardcover = /** @type {(inputs: Val_HardcoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capa Dura`)
};

const ko_val_hardcover = /** @type {(inputs: Val_HardcoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`양장본 (하드커버)`)
};

/**
* | output |
* | --- |
* | "Hardcover" |
*
* @param {Val_HardcoverInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_hardcover = /** @type {((inputs?: Val_HardcoverInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_HardcoverInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_hardcover(inputs)
	if (locale === "es") return es_val_hardcover(inputs)
	if (locale === "fr") return fr_val_hardcover(inputs)
	if (locale === "de") return de_val_hardcover(inputs)
	if (locale === "ja") return ja_val_hardcover(inputs)
	if (locale === "zh") return zh_val_hardcover(inputs)
	if (locale === "ar") return ar_val_hardcover(inputs)
	if (locale === "id") return id_val_hardcover(inputs)
	if (locale === "it") return it_val_hardcover(inputs)
	if (locale === "ru") return ru_val_hardcover(inputs)
	if (locale === "pt") return pt_val_hardcover(inputs)
	return ko_val_hardcover(inputs)
});